<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.0006 12.0001V17.4001M12.0006 7.50015V6.60015M13.5639 20.8633C15.0213 20.6059 16.3927 19.9931 17.5568 19.0792C18.7209 18.1654 19.6417 16.9787 20.2377 15.6241C20.8337 14.2695 21.0866 12.789 20.9739 11.3134C20.8612 9.83782 20.3864 8.41279 19.5916 7.16445C18.7159 5.78988 17.4833 4.6789 16.0255 3.95007C14.5677 3.22124 12.9393 2.90193 11.3142 3.02621C9.68904 3.15049 8.12815 3.71371 6.79812 4.65575C5.46809 5.59778 4.41884 6.88327 3.76237 8.37501C3.10589 9.86675 2.86682 11.5087 3.07069 13.1257C3.27455 14.7427 3.9137 16.274 4.9199 17.5561C5.92611 18.8383 7.2616 19.8231 8.78383 20.4056C10.3061 20.9881 11.9579 21.1463 13.563 20.8633H13.5639Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="square"
    />
  </svg>
</template>
